import { createCanvas } from "../../include/module";
createCanvas();

import { detectScroll } from "../../include/module";
detectScroll();

import { toggleHeader } from "../../include/module";
toggleHeader();

import { anchorLink } from "../../include/module";
anchorLink();

const tileText = () => {
  const breakPoint = 768;
  let windowWidthJ = $(window).width();
  $(window).on('load', function(){
    if (windowWidthJ > breakPoint) {
      $('.rec-Photo_List_Item_Body_Text').tile(3);
    }
  });
};
tileText();



// WEBPACK FOOTER //
// script.js